import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {isNullOrUndefined} from "util";
import 'rxjs/add/operator/map';


@Injectable()
export class ETagInterceptor implements HttpInterceptor{

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log(req.body);
    if(!isNullOrUndefined(req.body) && !isNullOrUndefined(req.body['eTag'])){
      return next.handle(req.clone({
        setHeaders: {
          "If-Match": req.body['eTag']
        }
      })).map(this.attachETagHeaderToBody);
    }else{
      return next.handle(req).map(this.attachETagHeaderToBody);
    }
  }


  private attachETagHeaderToBody(event: HttpEvent<any>){
    if(event instanceof HttpResponse && event.headers.has("etag")){
      let body = event.body;
      if (body instanceof Object) {
		  body['eTag']= event.headers.get("etag");
      }
      return event.clone({body: body});
    }else{
      return event;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/interceptors/e-tag.interceptor.ts